/**
 * Aligne le contenu du mega menu sous son menu parent.
 *
 * Le thème ancre le panneau sur toute la largeur de l'en-tête (left: 0), si
 * bien que ses colonnes de liens démarrent à la marge de page et paraissent
 * détachées du menu qui les ouvre. On garde ce panneau pleine largeur — c'est
 * lui qui porte le fond — et on ne décale que la grille intérieure.
 *
 * L'écart ne peut pas se calculer en CSS : il dépend de la position du <li>
 * dans la barre, que seul le layout connaît. On le mesure donc ici et on le
 * passe en variable CSS.
 */

const ITEM = '.menu-list__list-item:not([slot="overflow"])';
const VAR = '--submenu-align-offset';

/** Part de la grille au-delà de laquelle on cesse de décaler. */
const MAX_SHIFT_RATIO = 0.5;

/**
 * Abscisse du premier caractère réellement peint dans un élément.
 * Un Range sur le contenu ignore les paddings et bordures du conteneur, donc
 * la mesure correspond à ce que l'œil compare.
 */
function debutDuTexte(el) {
  const plage = document.createRange();
  plage.selectNodeContents(el);
  const box = plage.getBoundingClientRect();
  plage.detach && plage.detach();
  return box.width ? box.left : el.getBoundingClientRect().left;
}

function align(item) {
  const submenu = item.querySelector(':scope > .menu-list__submenu');
  const grid = submenu && submenu.querySelector('.mega-menu__grid');
  if (!grid) return;

  // On aligne les TEXTES, pas les boîtes. Le titre du menu parent porte un
  // padding-inline que les liens du sous-menu n'ont pas : comparer les bords
  // de boîte laisse un décalage de la valeur de ce padding, visible à l'œil.
  const titreParent = item.querySelector('.menu-list__link-title') || item;
  const premierLien = grid.querySelector('.mega-menu__link') || grid;

  // Remettre à zéro avant de mesurer, sinon on mesure notre propre décalage.
  submenu.style.setProperty(VAR, '0px');

  const gridBox = grid.getBoundingClientRect();
  if (!gridBox.width) return;

  const wanted = debutDuTexte(titreParent) - debutDuTexte(premierLien);
  const ceiling = gridBox.width * MAX_SHIFT_RATIO;
  const offset = Math.max(0, Math.min(wanted, ceiling));

  submenu.style.setProperty(VAR, Math.round(offset) + 'px');
}

function alignAll() {
  document.querySelectorAll(ITEM).forEach(align);
}

function watch(item) {
  if (item.dataset.megaMenuAligned) return;
  item.dataset.megaMenuAligned = 'true';
  // Aligner juste avant l'ouverture : les largeurs sont alors définitives.
  item.addEventListener('pointerenter', () => align(item));
  item.addEventListener('focusin', () => align(item));
}

function start() {
  document.querySelectorAll(ITEM).forEach(watch);
  alignAll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}

// La barre de menu se réorganise au redimensionnement (menu « More »),
// et le thème peut réinjecter ses éléments : on se resynchronise.
let pending;
window.addEventListener('resize', () => {
  clearTimeout(pending);
  pending = setTimeout(start, 150);
});
